import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

const ROUTED = {
  Loans: '/services#loans',
  Airtime: '/services#airtime',
  Data: '/services#data',
  Electricity: '/services#electricity',
  'Cable TV': '/services#cable-tv',
  'Credit Report': '/credit-report',
  About: '/about',
  Careers: '/careers',
  Blog: '/blog',
  Press: '/press',
  Contact: '/contact',
  'Privacy Policy': '/privacy',
  'Terms of Service': '/terms',
  'Cookie Policy': '/cookies',
};

const COLUMNS = [
  { heading: 'Services', links: ['Loans', 'Airtime', 'Data', 'Electricity', 'Cable TV', 'Credit Report'] },
  { heading: 'Company',  links: ['About', 'Careers', 'Blog', 'Press', 'Contact'] },
  { heading: 'Legal',    links: ['Privacy Policy', 'Terms of Service', 'Cookie Policy'] },
];

export default function PublicFooter() {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', padding: '2.5rem 5%', background: 'var(--surface)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '2rem' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <img src={logo} alt="PCredit" style={{ height: 28, width: 'auto' }} />
          </div>
          <p style={{ fontSize: '0.78rem', color: 'var(--text-3)', maxWidth: 220 }}>
            Nigeria's all-in-one financial platform for loans, bills, and more.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '3rem', flexWrap: 'wrap' }}>
          {COLUMNS.map(({ heading, links }) => (
            <div key={heading}>
              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-1)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' }}>{heading}</div>
              {links.map(l => (
                ROUTED[l] ? (
                  <Link key={l} to={ROUTED[l]} style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-3)', marginBottom: '0.4rem', textDecoration: 'none' }}
                    onMouseEnter={e => e.target.style.color = 'var(--text-2)'}
                    onMouseLeave={e => e.target.style.color = 'var(--text-3)'}
                  >{l}</Link>
                ) : (
                  <div key={l} style={{ fontSize: '0.8rem', color: 'var(--text-3)', marginBottom: '0.4rem', cursor: 'pointer' }}
                    onMouseEnter={e => e.target.style.color = 'var(--text-2)'}
                    onMouseLeave={e => e.target.style.color = 'var(--text-3)'}
                  >{l}</div>
                )
              ))}
            </div>
          ))}
        </div>
      </div>
      <div style={{ maxWidth: 1100, margin: '2rem auto 0', paddingTop: '1.5rem', borderTop: '1px solid var(--border)', fontSize: '0.75rem', color: 'var(--text-3)', textAlign: 'center' }}>
        © {new Date().getFullYear()} PCredit™. PCredit and the PCredit logo are trademarks of Premiumreal Technologies Limited. All rights reserved.
      </div>
    </footer>
  );
}
